<template>

  <div class="header-box-img">
    <div class="header-logos">
      <img src="../../../assets/homes/header-logos.png" alt="">
    </div>
    <div class="home-icon">
      <img src="../../../assets/homes/home-icon-bai.png" alt="">
    </div>

  </div>
</template>
<script>
import { dateFormat } from '../../../libs/util'
// import { vMiniWeather, vMiniWeatherIcon } from 'vue-mini-weather'

import axios from 'axios';

export default {
  props: {

  },
  data () {
    return {

    }
  },
  filters: {},
  components: {

  },
  created () {
  },
  mounted () {


  },
  methods: {


  },
}
</script>

<style lang="less" scoped>
@import './../../../common/homeInfo.less';
</style>


